import { motion } from "framer-motion";

const STEPS = [
  {
    num: "01",
    title: "Request",
    text: "Book online in under two minutes or call dispatch. Describe the issue, pick your window.",
  },
  {
    num: "02",
    title: "Dispatch",
    text: "A vetted master technician is assigned with full job context — no repeating yourself on site.",
  },
  {
    num: "03",
    title: "Restore",
    text: "Fixed right the first visit where possible, with photo-documented before and after.",
  },
  {
    num: "04",
    title: "Report",
    text: "Transparent digital invoice and a maintenance record for your property's history file.",
  },
];

export const Process = () => {
  return (
    <section id="process" className="py-16 sm:py-24 lg:py-32" data-testid="process-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-jbmono text-xs uppercase tracking-[0.25em] text-[#FF2A3B] font-semibold" data-testid="process-eyebrow">
            ✦ Operating Procedure
          </p>
          <h2 className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight" data-testid="process-heading">
            From request to report in four moves.
          </h2>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative rounded-xl border border-white/10 p-7 transition-colors hover:border-[#FF2A3B]/40"
              data-testid={`process-step-${s.num}`}
            >
              <span className="font-jbmono text-sm text-[#FF2A3B] tracking-[0.2em]">{s.num}</span>
              <h3 className="mt-4 font-display text-xl font-bold tracking-tight">{s.title}</h3>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">{s.text}</p>
              {i < STEPS.length - 1 && (
                <span className="hidden lg:block absolute top-9 -right-3 h-px w-6 bg-[#FF2A3B]/50" aria-hidden="true" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
